var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-modal',{attrs:{"visible":_vm.value,"message":_vm.message,"text":"会員情報ページへ戻る"},on:{"close":_vm.close,"yes":_vm.yes}})}
var staticRenderFns = []

export { render, staticRenderFns }